import React from 'react';
import { useKeycloak } from '@react-keycloak/web';
import cn from 'classnames';
import logoWhite from 'assets/img/svg/logo-100x22-white.svg';
import logoViolet from 'assets/img/svg/logo-100x22-violet.svg';
import styles from './login.module.scss';
import { setUser } from 'models/user';
import { useLocation, useNavigate } from 'react-router-dom';
import { setStoreStr } from 'models/store';
import { GroupsEnum } from 'types/users';


function Button(props: any) {
	if (!props) {
		return <button></button>;
	}
	const { children, className, isWhite, ...otherProps } = props;

	return (
		<button {...otherProps} className={cn(styles.button, { [styles.isWhite]: isWhite }, className)}>
			{children}
		</button>
	);
}

export default function Login() {
	const { keycloak } = useKeycloak();
	const navigate = useNavigate();

	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const ref = queryParams.get('ref') || '/';

	React.useEffect(() => {
		if (!keycloak.authenticated || !keycloak.tokenParsed) return;

		const tp = keycloak.tokenParsed as Record<string, unknown>;
		const groups = (Array.isArray(tp.groups) ? (tp.groups as string[]) : []).map(g => g.toLowerCase());

		setUser({
			...keycloak.tokenParsed,
			groups,
		});

		if (
			groups.indexOf(GroupsEnum.CLIENT) > -1 &&
			keycloak.tokenParsed.worklist
		) {
			setStoreStr(keycloak.tokenParsed.worklist);
		}

		navigate(ref);
	}, [keycloak.authenticated]);

	return (
		<>
			{!keycloak.authenticated ? (
				<div
					style={{ height: '100%' }}
					className={cn(styles.container, { [styles.authorized]: keycloak.authenticated })}
				>
					<header className={cn(styles.header, { container: keycloak.authenticated })}>
						{<img src={keycloak.authenticated ? logoViolet : logoWhite} alt="" />}
					</header>
					<div className={cn(styles.content, { container: keycloak.authenticated })}>
						<div className={styles.wrapper}>
							<div className={styles.container}>
								<div className={styles.title}>Войти в сервис контроля рекламных размещений</div>
								<Button isWhite onClick={() => keycloak.login()}>
									Войти
								</Button>
							</div>
						</div>
					</div>
				</div>
			) : (
				<></>
			)}
		</>
	);
}
